import { lazyLoadView } from '@utils/LazyLoad'
import { isNav2026Enabled } from '@modules/navegacao-v2/utils/nav2026-enabled'

// Rotas exclusivas da navegação 2026. Hoje só a página de Perfil do cliente
// (contexto cliente). Os demais módulos reaproveitam as rotas reais já
// existentes da plataforma.
export default [
  {
    // `:id?` opcional: entrar via switcher (sem id) continua funcionando; com id
    // a página hidrata o cliente e torna a rota compartilhável por link.
    path: '/cliente-perfil/:id?',
    name: 'cliente-perfil',
    meta: {
      // Gate consistente com o resto da nav 2026: `isNav2026Enabled` respeita a
      // flag do backend OU o override de dev (localStorage.nav2026). O `can_show`
      // cru olhava só a flag e, no F5, derrubava em /404 quando a flag ainda não
      // está no backend (ex.: migration pendente) mesmo com a nav v2 ligada via
      // localStorage. customPermission roda no guard global (router/index.js).
      permission: ['all'],
      customPermission: ({ show }) => isNav2026Enabled(show),
    },
    component: () =>
      lazyLoadView(import('@modules/navegacao-v2/components/client-profile.vue')),
  },
]
